import(/* webpackMode: "eager" */ "/home/ubuntu/joy-awards-build-folder/joy-awards-frontend-v3/src/app/global-error.tsx");
